/* staysake-guide.js: the per-order guide page. No dependencies.
   Reads g/o/k/n from the URL, talks to the keys Worker, renders the filter UI and the stay grid.
   g can be a continent (europe, asia, americas, africa, oceania), "everything", or a country slug
   (italy, united-kingdom). The filter rows adapt to that scope.
*/
(function () {
  'use strict';

  var CONTINENTS = {
    europe: 'Europe',
    asia: 'Asia',
    americas: 'The Americas',
    africa: 'Africa',
    oceania: 'Oceania'
  };
  var VIBES = {
    couples: 'Couples',
    group: 'Big group',
    coast: 'By the sea',
    city: 'City',
    countryside: 'Countryside'
  };
  /* picking one of these clears the other: they can't both be true of one stay */
  var VIBE_OPPOSITES = {
    couples: 'group',
    group: 'couples',
    city: 'coast',
    coast: 'city',
    countryside: 'city'
  };
  var SLEEPS = {
    '2': { label: 'Just us', min: 1, max: 2 },
    '3-5': { label: '3 to 5', min: 3, max: 5 },
    '6+': { label: '6 or more', min: 6, max: 9999 }
  };
  var FEATURES = {
    'pool': 'Pool or hot tub',
    'sea view': 'Sea view',
    'beach access': 'On the beach',
    'mountain view': 'Mountain view',
    'lake': 'Lake',
    'fireplace': 'Fireplace',
    'sauna': 'Sauna',
    'tennis': 'Tennis court',
    'gym': 'Gym',
    'pets ok': 'Pets welcome',
    'ev charger': 'EV charger'
  };
  var SORTS = {
    rating: 'Top rated',
    reviews: 'Most reviewed',
    big: 'Biggest'
  };
  var TINTS = [
    ['#C9D1C2', '#D0DBE2'],
    ['#E6C8B3', '#E9DFC3'],
    ['#D0DBE2', '#DCD7E1'],
    ['#E9DFC3', '#E6C8B3'],
    ['#DCD7E1', '#EADDD3']
  ];
  var PAGE = 72;
  var COUNTRY_LIMIT = 10;
  var REGION_LIMIT = 8;

  function $(root, sel) {
    return root.querySelector(sel);
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function slug(s) {
    return String(s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }
  function possessive(name) {
    if (!name) return 'Your';
    return name + (/s$/i.test(name) ? '’' : '’s');
  }
  function fmtDate(s) {
    var d = new Date(s);
    if (isNaN(d.getTime())) return '';
    try {
      return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
    } catch (e) {
      return '';
    }
  }
  function plural(n, one, many) {
    return n + ' ' + (n === 1 ? one : many);
  }
  function countBy(list, key) {
    var m = {};
    for (var i = 0; i < list.length; i++) {
      var v = list[i][key];
      if (v) m[v] = (m[v] || 0) + 1;
    }
    return m;
  }
  function keysByCount(m) {
    return Object.keys(m).sort(function (a, b) {
      return m[b] - m[a] || (a < b ? -1 : a > b ? 1 : 0);
    });
  }

  /* tidy Airbnb's inconsistent region strings so one place = one chip */
  var REGION_ALIASES = {
    'greater london': 'London', 'city of london': 'London',
    'lisboa': 'Lisbon', 'lisbon area': 'Lisbon', 'lisbon district': 'Lisbon',
    'setubal': 'Setúbal', 'algarve': 'Faro',
    'comunidad de madrid': 'Madrid', 'community of madrid': 'Madrid',
    'canarias': 'Canary Islands', 'las palmas': 'Canary Islands',
    'castilla y león': 'Castile and León', 'euskadi': 'Basque Country', 'país vasco': 'Basque Country',
    'menorca': 'Balearic Islands', 'sant josep de sa talaia': 'Balearic Islands',
    'noord-holland': 'North Holland', 'nh': 'North Holland', 'zuid-holland': 'South Holland', 'fr': 'Friesland',
    'idf': 'Île-de-France', "provence-alpes-cote d'azur": 'Provence', 'var': 'Provence', 'vaucluse': 'Provence',
    'basse-normandie': 'Normandie', 'lower normandy': 'Normandie', 'aquitaine': 'Nouvelle-Aquitaine',
    'rhône-alpes': 'Auvergne-Rhône-Alpes', 'ardèche': 'Auvergne-Rhône-Alpes', 'centre': 'Centre-Val de Loire',
    'alsace': 'Grand Est', 'burgundy': 'Bourgogne', 'brittany': 'Bretagne',
    'fi': 'Tuscany', 'montalcino': 'Tuscany', 'so': 'Lombardy', 'bergamo': 'Lombardy', 'brescia': 'Lombardy', 'lecco': 'Lombardy',
    'salerno': 'Campania', 'brindisi': 'Puglia', 'taranto': 'Puglia',
    'egeo': 'Aegean Islands', 'αιγαίο': 'Aegean Islands', 'cyclades': 'Cyclades', 'kuklades': 'Cyclades',
    'dodekanisos': 'Dodecanese', 'paros island': 'Paros', 'hydra': 'Hydra', 'ydra': 'Hydra', 'attica': 'Athens',
    'cymru': 'Wales', 'caernarfon': 'Wales', 'tobermory': 'Scotland', 'city of edinburgh': 'Edinburgh', 'midlothian': 'Edinburgh',
    'cumbria/northumberland': 'Cumbria', 'kronoberg county': 'Kronoberg', 'dalarna county': 'Dalarna'
  };
  function normRegion(region) {
    var r = (region || '').trim();
    if (!r) return r;
    r = r.replace(/^(county|co\.|state of|province of|provincia de|região de)\s+/i, '');
    r = r.replace(/\s+(district|county|province|län|region)$/i, '');
    var a = REGION_ALIASES[r.toLowerCase()];
    return a || r;
  }

  /* ---------- device id (localStorage, with fallbacks) ---------- */
  function deviceId() {
    var KEY = 'staysake_device';
    var id = '';
    try {
      id = localStorage.getItem(KEY) || '';
    } catch (e) {}
    if (!id) {
      try {
        id = sessionStorage.getItem(KEY) || '';
      } catch (e) {}
    }
    if (!/^[A-Za-z0-9_-]{8,64}$/.test(id)) {
      id = randomId();
      try {
        localStorage.setItem(KEY, id);
      } catch (e) {
        try {
          sessionStorage.setItem(KEY, id);
        } catch (e2) {}
      }
    }
    return id;
  }
  function randomId() {
    var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    var out = 'd';
    var buf = new Uint8Array(24);
    if (window.crypto && crypto.getRandomValues) crypto.getRandomValues(buf);
    else for (var j = 0; j < buf.length; j++) buf[j] = Math.floor(Math.random() * 256);
    for (var i = 0; i < buf.length; i++) out += chars[buf[i] % chars.length];
    return out;
  }

  /* ---------- listing data: accept the compact demo rows or plain objects ---------- */
  function expand(data) {
    if (!data) return [];
    var rows = Array.isArray(data) ? data : data.rows || data.listings || [];
    var conts = data.continents || [];
    var vibeNames = data.vibes || Object.keys(VIBES);
    var out = [];
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      if (Array.isArray(r)) {
        var vibes = [];
        for (var v = 0; v < vibeNames.length; v++) if (r[11] & (1 << v)) vibes.push(vibeNames[v]);
        out.push({
          id: r[0],
          name: r[1],
          town: r[2],
          region: normRegion(r[3]),
          country: r[4],
          continent: conts[r[5]] || 'unsorted',
          guests: r[6] == null ? null : r[6],
          bedrooms: r[7] == null ? null : r[7],
          rating: r[8] == null ? null : r[8],
          reviews: r[9] == null ? null : r[9],
          url: 'https://www.airbnb.co.uk/rooms/' + r[10],
          image: r[12] ? 'https://a0.muscache.com/im/pictures/' + r[12] + '?im_w=480' : '',
          vibes: vibes,
          favourite: false,
          note: ''
        });
      } else if (r && (r.url || r.link)) {
        out.push({
          id: r.id != null ? r.id : i,
          name: r.name || 'A stay',
          town: r.town || '',
          region: normRegion(r.region || ''),
          country: r.country || '',
          continent: (r.continent || 'unsorted').toLowerCase(),
          guests: r.guests != null ? parseInt(r.guests, 10) || null : null,
          bedrooms: r.bedrooms != null ? parseInt(r.bedrooms, 10) || null : null,
          rating: r.rating != null ? parseFloat(r.rating) || null : null,
          reviews: r.reviews != null ? parseInt(r.reviews, 10) || null : null,
          url: r.url || r.link,
          vibes: Array.isArray(r.vibes) ? r.vibes : String(r.vibes || '').split(/[,\s]+/).filter(Boolean),
          favourite: !!r.favourite,
          note: r.note || ''
        });
      }
    }
    return out;
  }

  /* ---------- one guide page ---------- */
  function GuidePage(root) {
    this.root = root;
    this.worker = (root.getAttribute('data-worker-url') || '').replace(/\/+$/, '');
    var q = new URLSearchParams(location.search);
    this.g = slug(q.get('g') || '');
    this.o = q.get('o') || '';
    this.k = q.get('k') || '';
    this.n = (q.get('n') || '').trim().slice(0, 40);
    this.demo = '';
    this.wantCountry = (q.get('country') || '').trim().slice(0, 60);
    this.device = deviceId();
    this.items = [];
    this.scope = { type: 'everything', continent: null, country: null };
    this.state = { continent: null, country: null, region: null, vibes: {}, feats: {}, sleeps: null, sort: 'rating', moreCountries: false, moreRegions: false };
    this.shown = PAGE;
    this.states = {
      loading: $(root, '[data-state="loading"]'),
      bad: $(root, '[data-state="bad"]'),
      locked: $(root, '[data-state="locked"]'),
      error: $(root, '[data-state="error"]'),
      guide: $(root, '[data-state="guide"]')
    };
    this.bindForms();
    this.start();
  }

  GuidePage.prototype.show = function (name) {
    for (var k in this.states) if (this.states[k]) this.states[k].hidden = k !== name;
  };

  GuidePage.prototype.request = function (path, opts) {
    opts = opts || {};
    var headers = { 'X-Device': this.device };
    if (opts.body) headers['Content-Type'] = 'application/json';
    return fetch(this.worker + path, {
      method: opts.method || 'GET',
      headers: headers,
      body: opts.body ? JSON.stringify(opts.body) : undefined,
      credentials: 'omit',
      cache: 'no-store'
    }).then(function (res) {
      return res
        .json()
        .catch(function () {
          return {};
        })
        .then(function (data) {
          return { status: res.status, data: data };
        });
    });
  };

  GuidePage.prototype.start = function () {
    var self = this;
    var tpl = this.root.getAttribute('data-template') || '';
    if (tpl !== 'guide' && !this.k) {
      var host = this.root.closest('.shopify-section') || this.root;
      host.hidden = true;
      return;
    }
    if (!this.worker || !/^[a-z-]{2,40}$/.test(this.g) || !/^[0-9]+$/.test(this.o) || !/^[0-9a-fA-F]{64}$/.test(this.k)) {
      this.show('bad');
      return;
    }
    this.show('loading');
    var qs = '?g=' + encodeURIComponent(this.g) + '&o=' + encodeURIComponent(this.o) + '&k=' + encodeURIComponent(this.k);
    if (this.n) qs += '&n=' + encodeURIComponent(this.n);
    this.request('/v' + qs)
      .then(function (r) {
        if (r.status === 403 || r.status === 404) return self.show('bad');
        if (r.status !== 200 || !r.data.ok) return self.show('error');
        if (r.data.locked) return self.show('locked');
        self.name = (r.data.name || self.n || '').trim();
        return self.loadData();
      })
      .catch(function () {
        self.show('error');
      });
  };

  GuidePage.prototype.loadData = function () {
    var self = this;
    var qs = '?o=' + encodeURIComponent(this.o) + '&k=' + encodeURIComponent(this.k);
    return this.request('/data/' + encodeURIComponent(this.g) + qs).then(function (r) {
      if (r.status === 403 && r.data.error === 'locked') return self.show('locked');
      if (r.status === 403 || r.status === 404) return self.show('bad');
      if (r.status !== 200 || !(Array.isArray(r.data) || r.data.rows || r.data.listings)) return self.show('error');
      self.load(r.data, false);
    });
  };

  /* ---------- forms: unlock, retry, clear, more, request ---------- */
  GuidePage.prototype.bindForms = function () {
    var self = this;
    var form = $(this.root, '[data-unlock-form]');
    if (form) {
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var input = $(form, 'input[type="email"]');
        var btn = $(form, 'button');
        var msg = $(self.root, '[data-unlock-msg]');
        var email = (input.value || '').trim();
        if (!email) return;
        btn.disabled = true;
        msg.className = 'sg__msg';
        msg.textContent = 'Checking…';
        self
          .request('/unlock', { method: 'POST', body: { o: self.o, k: self.k, email: email } })
          .then(function (r) {
            btn.disabled = false;
            if (r.status === 200 && r.data.ok) {
              msg.textContent = 'Lovely, you’re in.';
              self.start();
              return;
            }
            msg.className = 'sg__msg sg__msg--bad';
            if (r.status === 429) msg.textContent = 'Too many tries for now. Give it an hour and try again.';
            else if (r.status === 403 && r.data.error === 'no_match') msg.textContent = 'That’s not the email on the order. Try another?';
            else if (r.status === 400) msg.textContent = 'That doesn’t look like an email address.';
            else msg.textContent = 'Something went wrong. Try again in a moment, or reply to your order email.';
          })
          .catch(function () {
            btn.disabled = false;
            msg.className = 'sg__msg sg__msg--bad';
            msg.textContent = 'Couldn’t reach the server. Check your connection and try again.';
          });
      });
    }
    var retry = $(this.root, '[data-retry]');
    if (retry) retry.addEventListener('click', function () { self.start(); });

    var clears = this.root.querySelectorAll('[data-clear]');
    for (var i = 0; i < clears.length; i++) {
      clears[i].addEventListener('click', function () {
        self.resetState();
        self.render();
      });
    }
    var more = $(this.root, '[data-more]');
    if (more) {
      more.addEventListener('click', function () {
        self.shown += PAGE;
        self.render(true);
      });
    }
    var toggles = this.root.querySelectorAll('[data-request-toggle]');
    var panel = $(this.root, '[data-request]');
    for (var t = 0; t < toggles.length; t++) {
      toggles[t].addEventListener('click', function () {
        if (!panel) return;
        panel.hidden = false;
        try {
          panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (e) {
          panel.scrollIntoView();
        }
        var first = panel.querySelector('input, textarea');
        if (first) first.focus();
      });
    }
  };

  GuidePage.prototype.resetState = function () {
    var s = this.state;
    s.continent = this.scope.type === 'everything' ? null : this.scope.continent;
    s.country = this.scope.type === 'country' ? this.scope.country : null;
    s.region = null;
    s.vibes = {};
    s.feats = {};
    s.sleeps = null;
    s.moreCountries = false;
    s.moreRegions = false;
  };

  /* ---------- load + scope ---------- */
  GuidePage.prototype.load = function (data, isDemo) {
    var all = expand(data).filter(function (w) {
      return w.continent !== 'unsorted';
    });
    this.generated = data && data.generated ? data.generated : '';
    if (isDemo) this.name = this.n || 'Sully';

    /* work out what they bought from g */
    var g = this.g;
    var scope = { type: 'everything', continent: null, country: null };
    if (CONTINENTS[g]) scope = { type: 'continent', continent: g, country: null };
    else if (g !== 'everything') {
      for (var i = 0; i < all.length; i++) {
        if (slug(all[i].country) === g) {
          scope = { type: 'country', continent: all[i].continent, country: all[i].country };
          break;
        }
      }
      if (scope.type === 'everything' && !isDemo) return this.show('bad');
    }
    this.scope = scope;
    this.items = all.filter(function (w) {
      if (scope.type === 'continent') return w.continent === scope.continent;
      if (scope.type === 'country') return w.country === scope.country;
      return true;
    });
    this.resetState();
    if (this.wantCountry && scope.type !== 'country') {
      var want = this.wantCountry.toLowerCase();
      for (var j = 0; j < this.items.length; j++) {
        if ((this.items[j].country || '').toLowerCase() === want) {
          this.state.country = this.items[j].country;
          this.state.continent = this.items[j].continent;
          break;
        }
      }
    }
    this.shown = PAGE;
    this.renderHeader();
    this.render();
    this.show('guide');
  };

  GuidePage.prototype.guideName = function () {
    var s = this.scope;
    if (s.type === 'country') return s.country;
    if (s.type === 'continent') return CONTINENTS[s.continent];
    return 'Everything';
  };

  GuidePage.prototype.renderHeader = function () {
    var guideName = this.guideName();
    var who = possessive(this.name) + ' ' + guideName + ' guide';
    var built = this.generated ? fmtDate(this.generated) : '';
    var meta = plural(this.items.length, 'stay', 'stays') + (built ? ' · checked ' + built : '');
    $(this.root, '[data-who]').textContent = (this.demo ? 'Preview · ' : '') + meta;
    $(this.root, '[data-title]').textContent = who;
    var foot = $(this.root, '[data-made-for]');
    if (foot) foot.textContent = this.name ? 'Made for ' + this.name + ' ♡' : 'Made for you ♡';
    var hidden = $(this.root, '[data-request-guide]');
    if (hidden) hidden.value = guideName + (this.o ? ' (order ' + this.o + ')' : ' (preview)');
    try {
      document.title = who + (this.demo ? ' (preview)' : '') + ' · Staysake';
    } catch (e) {}
    var rows = { continent: this.scope.type === 'everything', country: this.scope.type !== 'country' };
    for (var k in rows) {
      var row = $(this.root, '[data-row="' + k + '"]');
      if (row) row.hidden = !rows[k];
    }
  };

  /* ---------- chips ---------- */
  function chip(label, cls, on, cb) {
    var b = el('button', 'sg__chip' + (cls ? ' ' + cls : ''), label);
    b.type = 'button';
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.addEventListener('click', cb);
    return b;
  }
  /* top-N chips with a "+N more" toggle so a busy country doesn't become a wall */
  function chipRow(container, keys, limit, expanded, cls, isOn, onPick, onMore) {
    var visible = keys;
    var hidden = 0;
    if (!expanded && keys.length > limit + 1) {
      visible = keys.slice(0, limit);
      for (var i = limit; i < keys.length; i++) if (isOn(keys[i])) visible.push(keys[i]);
      hidden = keys.length - visible.length;
    }
    visible.forEach(function (k) {
      container.appendChild(chip(k, cls, isOn(k), function () { onPick(k); }));
    });
    if (hidden > 0) container.appendChild(chip('+' + hidden + ' more', 'sg__chip--more', false, onMore));
    else if (expanded && keys.length > limit + 1) container.appendChild(chip('Show less', 'sg__chip--more', false, onMore));
  }

  GuidePage.prototype.renderChips = function () {
    var self = this;
    var s = this.state;
    var pool = this.items;

    if (this.scope.type === 'everything') {
      var cc = $(this.root, '[data-chips="continent"]');
      cc.innerHTML = '';
      var cm = countBy(pool, 'continent');
      keysByCount(cm).forEach(function (c) {
        cc.appendChild(
          chip(CONTINENTS[c] || c, 'sg__chip--k', s.continent === c, function () {
            s.continent = s.continent === c ? null : c;
            s.country = null;
            s.region = null;
            s.moreCountries = false;
            self.render();
          })
        );
      });
      if (s.continent)
        pool = pool.filter(function (w) {
          return w.continent === s.continent;
        });
    }

    if (this.scope.type !== 'country') {
      var c = $(this.root, '[data-chips="country"]');
      c.innerHTML = '';
      var km = countBy(pool, 'country');
      chipRow(c, keysByCount(km), COUNTRY_LIMIT, !!s.moreCountries, 'sg__chip--c',
        function (k) { return s.country === k; },
        function (k) { s.country = s.country === k ? null : k; s.region = null; s.moreRegions = false; self.render(); },
        function () { s.moreCountries = !s.moreCountries; self.renderChips(); });
    }

    var rrow = $(this.root, '[data-row="region"]');
    var r = $(this.root, '[data-chips="region"]');
    r.innerHTML = '';
    if (s.country) {
      var rm = countBy(
        pool.filter(function (w) {
          return w.country === s.country;
        }),
        'region'
      );
      var regions = keysByCount(rm);
      chipRow(r, regions, REGION_LIMIT, !!s.moreRegions, '',
        function (k) { return s.region === k; },
        function (k) { s.region = s.region === k ? null : k; self.render(); },
        function () { s.moreRegions = !s.moreRegions; self.renderChips(); });
      rrow.hidden = regions.length < 2;
    } else {
      rrow.hidden = true;
    }

    var v = $(this.root, '[data-chips="vibe"]');
    v.innerHTML = '';
    Object.keys(VIBES).forEach(function (k) {
      v.appendChild(
        chip(VIBES[k], '', !!s.vibes[k], function () {
          if (s.vibes[k]) delete s.vibes[k];
          else {
            s.vibes[k] = true;
            var opp = VIBE_OPPOSITES[k];
            if (opp) delete s.vibes[opp];
            if (k === 'city') delete s.vibes.countryside;
          }
          self.render();
        })
      );
    });

    var sl = $(this.root, '[data-chips="sleeps"]');
    sl.innerHTML = '';
    Object.keys(SLEEPS).forEach(function (k) {
      sl.appendChild(
        chip(SLEEPS[k].label, '', s.sleeps === k, function () {
          s.sleeps = s.sleeps === k ? null : k;
          self.render();
        })
      );
    });

    var frow = $(this.root, '[data-row="features"]');
    var fe = $(this.root, '[data-chips="features"]');
    if (frow && fe) {
      fe.innerHTML = '';
      var scoped = this.items.filter(function (w) {
        return (!s.continent || w.continent === s.continent) && (!s.country || w.country === s.country);
      });
      var scanned = scoped.filter(function (w) { return w.vibes.indexOf('scanned') !== -1; }).length;
      var show = scoped.length > 0 && scanned / scoped.length >= 0.5;
      frow.hidden = !show;
      if (!show) s.feats = {};
      if (show) {
        Object.keys(FEATURES).forEach(function (k) {
          var n = scoped.filter(function (w) { return w.vibes.indexOf(k) !== -1; }).length;
          if (!n) return;
          fe.appendChild(
            chip(FEATURES[k], '', !!s.feats[k], function () {
              if (s.feats[k]) delete s.feats[k];
              else s.feats[k] = true;
              self.render();
            })
          );
        });
      }
    }

    var so = $(this.root, '[data-chips="sort"]');
    if (so) {
      so.innerHTML = '';
      Object.keys(SORTS).forEach(function (k) {
        so.appendChild(
          chip(SORTS[k], '', s.sort === k, function () {
            s.sort = k;
            self.render();
          })
        );
      });
    }

    var any =
      (this.scope.type === 'everything' && s.continent) ||
      (this.scope.type !== 'country' && s.country) ||
      s.region ||
      s.sleeps ||
      Object.keys(s.vibes).length ||
      Object.keys(s.feats).length;
    var clears = this.root.querySelectorAll('[data-clear]');
    for (var i = 0; i < clears.length; i++) clears[i].hidden = !any;
  };

  /* ---------- tiles ---------- */
  GuidePage.prototype.tile = function (w, idx) {
    var a = el('a', 'sg__tile' + (w.favourite ? ' sg__tile--fav' : ''));
    a.href = w.url;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    var t = TINTS[idx % TINTS.length];
    var top = el('div', 'sg__img');
    top.style.setProperty('--a', t[0]);
    top.style.setProperty('--b', t[1]);
    if (w.image) {
      var im = document.createElement('img');
      im.src = w.image;
      im.alt = '';
      im.loading = 'lazy';
      im.decoding = 'async';
      im.onerror = function () { if (im.parentNode) im.parentNode.removeChild(im); };
      top.appendChild(im);
    }
    var stick = w.favourite ? 'My favourite ♡' : w.note || w.region || w.country;
    if (stick) top.appendChild(el('span', 'sg__sticker' + (w.favourite ? ' sg__sticker--fav' : ''), stick));
    if (w.rating) top.appendChild(el('span', 'sg__n', '★ ' + w.rating));
    a.appendChild(top);

    var body = el('div', 'sg__body');
    body.appendChild(el('h3', null, w.name));
    var where = [];
    if (w.town) where.push(w.town);
    if (w.region && w.region !== w.town) where.push(w.region);
    if (this.scope.type === 'everything' || !where.length) where.push(w.country);
    body.appendChild(el('span', 'sg__where', where.join(' · ')));
    var facts = [];
    if (w.guests) facts.push('Sleeps ' + w.guests);
    if (w.bedrooms) facts.push(plural(w.bedrooms, 'bed', 'beds'));
    if (w.reviews) facts.push(w.reviews + ' reviews');
    if (facts.length) body.appendChild(el('span', 'sg__facts', facts.join(' · ')));
    var ft = w.vibes.filter(function (v) { return FEATURES[v]; }).slice(0, 3);
    if (ft.length) {
      var tags = el('div', 'sg__tags');
      ft.forEach(function (v) { tags.appendChild(el('span', null, FEATURES[v])); });
      body.appendChild(tags);
    }
    body.appendChild(el('span', 'sg__open', 'Open on Airbnb →'));
    a.appendChild(body);
    return a;
  };

  GuidePage.prototype.render = function (keepShown) {
    if (!keepShown) this.shown = PAGE;
    this.renderChips();
    var s = this.state;
    var vibes = Object.keys(s.vibes);
    var feats = Object.keys(s.feats);
    var sl = s.sleeps ? SLEEPS[s.sleeps] : null;
    var list = this.items.filter(function (w) {
      for (var f = 0; f < feats.length; f++) if (w.vibes.indexOf(feats[f]) === -1) return false;
      if (s.continent && w.continent !== s.continent) return false;
      if (s.country && w.country !== s.country) return false;
      if (s.region && w.region !== s.region) return false;
      if (sl && (w.guests == null || w.guests < sl.min || w.guests > sl.max)) return false;
      for (var i = 0; i < vibes.length; i++) if (w.vibes.indexOf(vibes[i]) === -1) return false;
      return true;
    });
    list.sort(function (a, b) {
      if (a.favourite !== b.favourite) return a.favourite ? -1 : 1;
      if (s.sort === 'reviews') return (b.reviews || 0) - (a.reviews || 0);
      if (s.sort === 'big') return (b.guests || 0) - (a.guests || 0) || (b.rating || 0) - (a.rating || 0);
      return (b.rating || 0) - (a.rating || 0) || (b.reviews || 0) - (a.reviews || 0);
    });

    var grid = $(this.root, '[data-grid]');
    grid.innerHTML = '';
    var n = Math.min(list.length, this.shown);
    var frag = document.createDocumentFragment();
    for (var i = 0; i < n; i++) frag.appendChild(this.tile(list[i], i));
    grid.appendChild(frag);
    $(this.root, '[data-empty]').hidden = list.length > 0;
    var moreWrap = $(this.root, '[data-more-wrap]');
    var more = $(this.root, '[data-more]');
    if (moreWrap && more) {
      var left = list.length - n;
      moreWrap.hidden = left <= 0;
      more.textContent = 'Show ' + Math.min(left, PAGE) + ' more';
    }
    $(this.root, '[data-count]').textContent = n < list.length ? 'Showing ' + n + ' of ' + list.length : '';

    var bits = [];
    if (s.country) bits.push(s.country);
    else if (s.continent && this.scope.type === 'everything') bits.push('All of ' + CONTINENTS[s.continent].replace(/^The /, 'the '));
    else if (this.scope.type === 'continent') bits.push('All of ' + CONTINENTS[this.scope.continent].replace(/^The /, 'the '));
    else bits.push('Everywhere');
    if (s.region) bits.push(s.region);
    vibes.forEach(function (v) {
      bits.push(VIBES[v].toLowerCase());
    });
    feats.forEach(function (f) {
      bits.push(FEATURES[f].toLowerCase());
    });
    if (sl) bits.push('sleeps ' + SLEEPS[s.sleeps].label.toLowerCase());
    $(this.root, '[data-summary]').textContent = bits.join(' · ');
    $(this.root, '[data-total]').textContent = plural(list.length, 'stay', 'stays');
  };

  /* ---------- boot ---------- */
  function boot() {
    var roots = document.querySelectorAll('[data-staysake-guide]');
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i].__sg) roots[i].__sg = new GuidePage(roots[i]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
